import {ApplicationConfig, inject, provideBrowserGlobalErrorListeners, provideZoneChangeDetection} from '@angular/core';
import {provideClientHydration} from '@angular/platform-browser';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideRouter, Router} from '@angular/router';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandlerFn,
  HttpRequest, HttpStatusCode,
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';
import {catchError, Observable, tap} from 'rxjs';

import {AppService} from 'shared/services';
import {HOME_LIBRARY_CONFIG} from 'home';
import {LIBRARY_CONFIG as TOURNAMENTS_LIBRARY_CONFIG} from 'tournaments';
import {environment} from '../environments/environment';
import {routes} from './app.routes';

/**
 * Intercepta las peticiones HTTP
 * Si recibe un status 401 del API, significa que el JWT ya expiro,
 * por lo tanto, cierra la sesion y redirecciona a la pagina de login
 * @param req
 * @param next
 */
const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const appService: AppService = inject(AppService);
  const router: Router = inject(Router);

  req = req.clone({
    url: `${environment.apiUrl}/${req.url}`,
  });

  const accessToken: string | undefined = appService.token;
  if (accessToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    console.info('authInterceptor 000 envia token');
  } else {
    console.info('authInterceptor 000 NO envia token');
  }

  return next(req).pipe(
    tap((event): void => {
      console.info('authInterceptor 555', event);
      if (event.type === HttpEventType.Response) {
        console.info('authInterceptor 111');
        // @TODO: deprecated
        // if (event.status === HttpStatusCode.Unauthorized) {
        //   console.info('authInterceptor 222');
        //   // Cierra la sesion
        //   appService.logout();
        //
        //   // Redirecciona
        //   router.navigate(['/auth']);
        // }
      }
    }),
    catchError((errorResponse: HttpErrorResponse) => {
      console.info('authInterceptor catchError', errorResponse);
      if (errorResponse.status === HttpStatusCode.Unauthorized) {
        console.info('authInterceptor 222');
        // Cierra la sesion
        appService.logout();

        // Redirecciona
        router.navigate(['/auth']);
      }
      throw new Error();
    })
  );
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),

    // Eduardo
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    {provide: HOME_LIBRARY_CONFIG, useValue: environment.homeConfig},
    {provide: TOURNAMENTS_LIBRARY_CONFIG, useValue: environment.tournamentsConfig},
  ],
};
